export const customerTaxExemptOptions = [
  {
    'value': 'NO',
    'description': 'No'
  },
  {
    'value': 'YES',
    'description': 'Yes'
  }
];
